var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { SystemEvent, SystemEventLevel } from "./system-event";
var Logger = /** @class */ (function () {
    function Logger(logger) {
        var _this = this;
        this.event = logger.event || (function () { });
        var logAtLevel = function (level, message) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            if (_this.event) {
                _this.event.apply(_this, __spread([new SystemEvent(level, message)], args));
            }
        };
        this.info = logger.info || (function (message) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return logAtLevel.apply(void 0, __spread([SystemEventLevel.INFO, message], args));
        });
        this.warning = logger.warning || (function (message) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return logAtLevel.apply(void 0, __spread([SystemEventLevel.WARN, message], args));
        });
        this.error = logger.error || (function (message) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return logAtLevel.apply(void 0, __spread([SystemEventLevel.ERROR, message], args));
        });
    }
    return Logger;
}());
export { Logger };
//# sourceMappingURL=logger.js.map